import moment from "moment";
export const numberFormat = (num) => {
  return (
    "$" +
    parseFloat(num)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
  );
};
export const basicFormat = (value) => moment(value).format("L LT");
export const basicUTCFormat = (value) =>
  moment.utc(value).local().format("L LT");
export const formatDate = (value) =>
  `${moment(value).format("dddd")}, ${moment(value).format("MMMM Do, YYYY")}`;
export const formatShortDate = (value) => moment(value).format("M/DD");
export const simplyDateFormat = (value) => moment(value).format("l");
export const isDifferentDates = (date1, date2) =>
  moment(date1).diff(moment(date2), "days");
export const formatTime = (value) => moment(value).format("LT");
export const formatUTCTime = (value) => moment.utc(value).local().format("LT");
export const formatSmallDate = (value) =>
  moment(value).year() === moment().year()
    ? moment(value).format("MMM Do")
    : moment(value).format("MMM Do, YYYY");
